import React, { useMemo } from "react";
import { palette } from "lib/chartTheme";
import DistributionPie from "./DistributionPie";

const COLORS = [palette.deep, palette.sage];

const HomeownershipChart = ({ data }) => {
  const slices = useMemo(
    () => [
      { label: "Homeowners", value: data?.owners },
      { label: "Renters", value: data?.renters },
    ],
    [data]
  );
  return <DistributionPie slices={slices} colors={COLORS} emptyText="No homeownership data yet" />;
};

export default HomeownershipChart;
